import { Modal } from '@bp/ui-components';
import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './App.module.scss';
import { useHealthCheck } from 'hooks/useHealthCheck';

export const RequireBackend: FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation();
  const { modal, setModal, networkIsOnline, backendIsOnline } = useHealthCheck();

  return (
    <>
      {children}
      {modal && (
        <Modal isOpen={modal} onRequestClose={() => setModal(false)} title={t('offline.connectionIssues')}>
          <div className={styles['offline-container']}>
            <div className={styles.message}>
              {!networkIsOnline && <div>{t('offline.clientOffline')}</div>}
              {!backendIsOnline && <div>{t('offline.serverOffline')}</div>}
              <div>{t('offline.autoClose')}</div>
              <div>{t('offline.unsavedData')}</div>
            </div>
            <div className={styles.status}>
              <div>
                <div>Server</div>
                <span className={backendIsOnline ? styles.online : styles.offline}>
                  {backendIsOnline ? 'Online' : 'Offline'}
                </span>
              </div>
              <div>
                <div>Client</div>
                <span className={networkIsOnline ? styles.online : styles.offline}>
                  {networkIsOnline ? 'Online' : 'Offline'}
                </span>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
